<script setup lang="ts"></script>
<template>
    <div class="overflow-auto bg-white flex flex-col-reverse lg:flex-row lg:w-full h-screen w-full">
        <div
            class="relative border-t lg:border-t-0 lg:border-r border-gray-lightest z-40 w-full lg:w-72 flex-col"
        >
            <div class="grow bg-white text-gray-dark overflow-y-auto custom-scrollbar">
                <slot name="subnavigation" />
            </div>
        </div>
        <div class="lg:w-0 lg:h-screen grow">
            <slot />
        </div>
    </div>
</template>
